import { render, staticRenderFns } from "./economicBenefits.vue?vue&type=template&id=17de0c82"
import script from "./economicBenefits.vue?vue&type=script&lang=js"
export * from "./economicBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports